/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

export enum BundleDynamicCriteriaEnum {
    BUNDLE_CRITERIA_SPEC = 'bundleCriteriaSpec',
    BUNDLE_POSITION_CRITERIA_SPEC  = 'bundlePositionCriteriaSpec'
}
